var _path, _path2, _g, _rect, _rect2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoFal({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 65,
    viewBox: "0 0 160 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2170_41970)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M153.104 0.0439453H6.89566C3.08729 0.0439453 0 2.92542 0 6.47989V57.608C0 61.1625 3.08729 64.0439 6.89566 64.0439H153.104C156.913 64.0439 160 61.1625 160 57.608V6.47989C160 2.92542 156.913 0.0439453 153.104 0.0439453Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2170_41970",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 160,
    height: 65
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.89566 0.0439453H153.104C156.913 0.0439453 160 2.92542 160 6.47989V57.608C160 61.1625 156.913 64.0439 153.104 64.0439H6.89566C3.0873 64.0439 0 61.1625 0 57.608V6.47989C0 2.92542 3.0873 0.0439453 6.89566 0.0439453Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2170_41970)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.258 -13.6704L160.601 33.1746V-13.6704H113.258Z",
    fill: "#1B3761"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M135.128 -13.6442L111.469 9.76667L124.19 22.3571L160.6 -13.6704L135.128 -13.6442Z",
    fill: "#0778B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.261 -13.6442L136.92 9.76667L124.196 22.3571L87.7891 -13.6704L113.261 -13.6442Z",
    fill: "#0778B5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M-0.228794 183.472L94.8595 -55.3848H-23.0859L-0.228794 183.472Z",
    fill: "url(#paint0_linear_2170_41970)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M-28.1133 149.187L78.0181 -66.8135H-28.1133V149.187Z",
    fill: "url(#paint1_linear_2170_41970)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.60156,
    y: 12.8438,
    width: 38.4,
    height: 38.4,
    rx: 3.84,
    stroke: "#EDEFF0",
    strokeWidth: 0.685714
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.60156,
    y: 12.8438,
    width: 38.4,
    height: 38.4,
    fill: "url(#pattern0_2170_41970)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M104.166 31.07L96.2404 38.3617L99.8884 41.7266H94.3866V29.2948L91.9375 26.6812V43.9822H105.996L108.446 41.7266L112.094 38.3617L104.167 31.07H104.166ZM104.971 41.7284H103.353L99.7049 38.3636L104.166 34.2623L108.625 38.3636L104.971 41.7284Z",
    fill: "#1B3761"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9207 48.8491L76.2578 41.6816H79.7487L83.9207 45.5214L86.8012 42.8688V29.2962L89.3555 26.6826V43.8427L83.9207 48.8491Z",
    fill: "#1B3761"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M106.037 28.0486L104.169 26.3296L102.301 28.0486L104.169 29.7677L106.037 28.0486Z",
    fill: "#0778B5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7148 40.5632H71.2743V37.33H73.0006L73.3388 36.959H71.2743V34.223H74.1868L74.5257 33.8501H69.7148V40.5632Z",
    fill: "#0778B5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3201 33.4814L73.3047 40.5618H74.2355L75.0955 38.5398H78.0447L78.9047 40.5618H79.3481L76.3201 33.4814ZM75.2527 38.1689L76.5681 35.0767L77.8898 38.1689H75.2527Z",
    fill: "#0778B5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9579 40.1908V33.8506H80.3984V40.5637H81.6779H81.9579H84.8367V40.1908H81.9579Z",
    fill: "#0778B5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M93.9205 47.8513V48.3707H92.9051C92.1033 48.3707 91.5273 48.0331 91.5273 47.3282C91.5273 46.7272 92.0388 46.282 92.9051 46.282H92.9856V46.0965H93.5496V47.8513H93.9205ZM92.0228 45.5549C92.0228 45.3991 92.1593 45.2915 92.3371 45.2915C92.5142 45.2915 92.6513 45.3991 92.6513 45.5549C92.6513 45.7293 92.5062 45.822 92.3371 45.822C92.1679 45.822 92.0228 45.7293 92.0228 45.5549ZM92.9856 47.8513V46.8014H92.7679C92.4376 46.8014 92.0913 46.9944 92.0913 47.3282C92.0913 47.6621 92.4056 47.8513 92.7399 47.8513H92.9856ZM92.8971 45.5549C92.8971 45.3991 93.0336 45.2915 93.2113 45.2915C93.3885 45.2915 93.5256 45.3991 93.5256 45.5549C93.5256 45.7293 93.3805 45.822 93.2113 45.822C93.0422 45.822 92.8971 45.7293 92.8971 45.5549Z",
    fill: "#0778B5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8398 47.8506H94.6336V48.37H93.8398V47.8506Z",
    fill: "#0778B5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5547 47.8506H95.3484V48.37H94.5547V47.8506Z",
    fill: "#0778B5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M95.2695 47.8506H96.0632V48.37H95.2695V47.8506Z",
    fill: "#0778B5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M95.9844 47.8506H96.7781V48.37H95.9844V47.8506Z",
    fill: "#0778B5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6953 47.8506H97.489V48.37H96.6953V47.8506Z",
    fill: "#0778B5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M97.4062 47.851H97.8011V46.2817H98.3651V46.4672H99.5942C99.9565 46.4672 100.231 46.5488 100.432 46.7455C100.601 46.9124 100.666 47.1869 100.666 47.4912V47.851H101.101V48.3704H97.4062V47.851ZM98.3651 46.9829V47.851H100.102V47.4689C100.102 47.3205 100.065 47.2129 99.9931 47.1276C99.9245 47.046 99.7954 46.9829 99.6503 46.9829H98.3651Z",
    fill: "#0778B5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M101.027 47.8506H101.821V48.37H101.027V47.8506Z",
    fill: "#0778B5"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M101.738 47.8516H102.532V48.371H101.738V47.8516Z",
    fill: "#0778B5"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M102.445 47.8506H103.239V48.37H102.445V47.8506Z",
    fill: "#0778B5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M103.16 47.8509H104.832C104.872 47.6877 104.901 47.4762 104.901 47.3203C104.901 47.1645 104.844 46.9864 104.703 46.8715C104.59 46.7787 104.429 46.7305 104.228 46.7305C104.014 46.7305 103.853 46.7713 103.644 46.8937L103.41 46.4411C103.672 46.3038 103.958 46.2111 104.296 46.2111C104.634 46.2111 104.905 46.315 105.098 46.4967C105.312 46.6934 105.461 46.9865 105.461 47.3611C105.461 47.7544 105.344 48.1551 105.267 48.3702H103.16V47.8509ZM103.893 45.6212C103.893 45.458 104.038 45.3467 104.224 45.3467C104.409 45.3467 104.554 45.458 104.554 45.6212C104.554 45.803 104.401 45.8995 104.224 45.8995C104.046 45.8995 103.893 45.803 103.893 45.6212Z",
    fill: "#0778B5"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M105.81 49.1532L105.77 48.6338C105.874 48.6598 105.951 48.6672 106.035 48.6672C106.261 48.6672 106.338 48.5596 106.338 48.3036V46.2817H106.902V48.2295C106.902 48.9009 106.672 49.1866 106.096 49.1866C105.991 49.1866 105.878 49.1717 105.81 49.1532Z",
    fill: "#0778B5"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M137.81 27.1035L127.152 37.7609L137.81 48.4182L148.467 37.7609L137.81 27.1035ZM137.81 46.2107L129.36 37.7609L137.81 29.3111L146.26 37.7609L137.81 46.2107Z",
    fill: "#19D3C5"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M144.055 33.3462L140.746 36.6546L141.847 37.7556L144.055 35.5537L146.256 37.7556L144.055 39.9631L141.847 37.7556L140.746 38.8622L144.055 42.1649L148.464 37.7556L144.055 33.3462Z",
    fill: "#3D7CC9"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M133.398 31.5128L136.707 34.8156L137.808 33.7146L135.606 31.5128L137.808 29.3053L140.015 31.5128L137.808 33.7146L138.909 34.8156L142.217 31.5128L137.808 27.1035L133.398 31.5128Z",
    fill: "#3D7CC9"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M131.562 42.1649L134.87 38.8622L133.769 37.7556L131.562 39.9631L129.36 37.7556L131.562 35.5537L133.769 37.7556L134.87 36.6546L131.562 33.3462L127.152 37.7556L131.562 42.1649Z",
    fill: "#3D7CC9"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M142.217 44.0028L138.909 40.6943L137.808 41.801L140.015 44.0028L137.808 46.2103L135.606 44.0028L137.808 41.801L136.707 40.6943L133.398 44.0028L137.808 48.4121L142.217 44.0028Z",
    fill: "#3D7CC9"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M139.649 37.7551L137.811 35.917L135.973 37.7551L137.811 39.5932L139.649 37.7551Z",
    fill: "#19D3C5"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M149.889 36.9769H152.096L138.586 23.4722V25.6739L149.889 36.9769Z",
    fill: "#1C355E"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M138.586 49.8362V52.0437L152.096 38.5391H149.889L138.586 49.8362Z",
    fill: "#1C355E"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M137.032 49.8362L125.729 38.5391H123.527L137.032 52.0437V49.8362Z",
    fill: "#1C355E"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M137.032 25.6739V23.4722L123.527 36.9769H125.729L137.032 25.6739Z",
    fill: "#1C355E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_2170_41970",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2170_41970",
    transform: "scale(0.00471698)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2170_41970",
    x1: -90.1062,
    y1: 123.758,
    x2: 83.2544,
    y2: -70.8162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00537636,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2555,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4642,
    stopColor: "#F3F2F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.658,
    stopColor: "#E3E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8417,
    stopColor: "#CDCCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4B4B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2170_41970",
    x1: -78.5516,
    y1: 89.4722,
    x2: 78.9827,
    y2: -88.8192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00537636,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2555,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4642,
    stopColor: "#F3F2F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.658,
    stopColor: "#E3E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8417,
    stopColor: "#CDCCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4B4B4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2170_41970"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 64,
    fill: "white",
    transform: "translate(0 0.0439453)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2170_41970",
    width: 212,
    height: 212,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAANQAAADUCAYAAADk3g0YAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAA1KADAAQAAAABAAAA1AAAAAC8ArY6AAANA0lEQVR4Ae2c241txw1EZcMpOBHH5LAckxNRELI9XwcLRtctVe95HCx9DVFkkb0GRPfGCPe33/xPAhKQgAQkIAEJSEACEpCABCQgAQlIQAISkIAEJCABCUhAAhKQgAQkIAEJSEACEpCABCQgAQlIQAISkIAEJCABCUhAAhKQwM8g8Jd1zL//459/rB5N/e///tdx5nUe+tOPejP7/3Jbvza/nYf57EedMXmwnjrrUz511t+O07yp319TgroEJPDrBFyoX2dlpgQiARcqIjJBAr9O4G+/nvprmesblF3WN3Sah/6MWd/qPM8as//qx3qelzrjdh7mt/3afM7LmPNQb2NvqJaY+RI4EHChDnCUJNAScKFaYuZL4EDg+jcUe7Vv1PaNnPyp058x8xmn8yU/1qf4tl/q99P09PvheciT+hp7Q60ErZfACwEX6gWGP0pgJeBCrQStl8ALgce/oV56fcqP6Y3MNzfzGTN/PUTrz/zUn/mcnzr9mE+dMf3aeubTj/2+e+wN9d1/Q873owi4UD/q1+Ww352AC/Xdf0PO96MIvN03FOmnN3rS2zd98qPOeRnfzm/9OA9j+pEXdda/W+wN9W6/Uc/zpQRcqC/Fb/N3I+BCvdtv1PN8KYHHv6H4pv7S0/63Od/07Xypnn4pP+mJV1vf5qf+SSePlN/qT/u383hDtcTMl8CBgAt1gKMkgZaAC9USM18CBwLXv6H4Rj/0/hKJb27Oe1tfD5nmS/6p/rvrPB/npf7VsTfUV/8G7P9WBFyot/p1epivJuBCffVvwP5vReD474T/hJM+/abmN1Viss5zux/90nxtPnmwnvq7x95Q7/4b9nyfSsCF+lTcNnt3Ai7Uu/+GPd+nEpi/ofgm5xua+no6+tOP/dp8+rUx+3Ge1q/NZ/+2nvmc/7P92Z/ztfHt+dnfG4pEjCUwEHChBniWSoAEXCgSMZbAQOD6/8uXZrn9huUbO/kzv52X9exH/bY//diPMedjfRvTn/WpX6pf/dif/Ri3/ZjP2BuKRIwlMBBwoQZ4lkqABFwoEjGWwEBg/obim5WzJJ35t9+4yY/9OW9bn/yotzHnSfOmfPZP+dRZzzjlp/npxzjVtzr929gbqiVmvgQOBFyoAxwlCbQEXKiWmPkSOBCYv6EO3h9SekOn+vQGZn3bj/70Y9zms76dj/W3+9OPMedNepvP8zFmP+rsl/Tkx/o29oZqiZkvgQMBF+oAR0kCLQEXqiVmvgQOBK5/Q/FNyzcrdc6W8pOe/KgzTvMxP8X0S/Mnnf2YT72N13nZL/kxP8Xf3c8bKv0G1SVQEHChClimSiARcKESIXUJFASuf0Ol3nzz803M+jaf9fSnH/MZM7/1S/Xsl/yps54x+1OnH/Nbnf7Jj/lrzHnpx3mor7E31ErQegm8EHChXmD4owRWAi7UStB6CbwQ+PJ/ly+9afkmZn7SX876p36kP03aeVo/9mNMv3ae236ch/4pTvOznvnUOU/KZ30be0O1xMyXwIGAC3WAoySBloAL1RIzXwIHAte/oQ69PiS+Yds3bspvdc6b5mM+Y9ZTT3E7/1f347w83+356N/GnIfzU2/9vaFaYuZL4EDAhTrAUZJAS8CFaomZL4EDgce/ofgmbd+sbf7hrB9S67fmp3nIJ+VzHubTb81PfklP81HnvPRnfhs/7e8N1f5GzJfAgYALdYCjJIGWgAvVEjNfAgcC8zcUvds3apvPfozpRz29yW/Xs9/qz/O0Mfuv8yU/zsd86ow5H3XG9G/r6dfG3lAtMfMlcCDgQh3gKEmgJeBCtcTMl8CBwPxvStx+s9KPs/NNzHzqrF9j9qMf+zM/6fRb6+mXYs7H/NvztP04z9P17Jdib6hESF0CBQEXqoBlqgQSARcqEVKXQEHg8b9DpVn4Bk5v9OTHeua3/VY/9mfMeag/HfN8nGfVOX/yY36Kkx91+vG81NvYG6olZr4EDgRcqAMcJQm0BFyolpj5EjgQ+PK/Q6U3btJ5tttv4qf92/NxnhQnHtQ5z22d87If9TamX5q/9U/53lCJkLoECgIuVAHLVAkkAi5UIqQugYLA9b9Dpd584zKfb17qjOnH+qS3frfz6cf5qTNez0e/FLfz0Y/zUm/9kx/9U9z2p583FIkYS2Ag4EIN8CyVAAm4UCRiLIGBwPW/Q3EWvkkZpzcwddaz39P57Md5Uv+UT//kt+ZzHvoxTvNQZz37pXzqrF/9kx/9U+wNlQipS6Ag4EIVsEyVQCLgQiVC6hIoCMzfUHyD8s3LWZLOfPpTT3Hql/xTPfsnP+anuPVr83m+VE+d9TwP86mnuK1v52F+24/ze0ORiLEEBgIu1ADPUgmQgAtFIsYSGAjM/y9feoO2+nCWj9L2Dfz0fGke9v/s86d+nC+dh36pnjrr15jzpn7Mb/t7Q7XEzJfAgYALdYCjJIGWgAvVEjNfAgcC8zcUvdMblfl8s7KeOuvXfPq1cTtf68989vvs87M/50txmjfpyZ968ks6/VLsDZUIqUugIOBCFbBMlUAi4EIlQuoSKAjM31B8g6befIOzvtVTP+ptP9ZzPurJn/kpXv1Yz37pPMxPcduP+WmelE89zZv6pXrq3lAkYiyBgYALNcCzVAIk4EKRiLEEBgLzN1Tbm2/c9Q27+qV66um86TyrX6pnf+YnvT3fZ/tzPp6HOuejzjj5MZ+xNxSJGEtgIOBCDfAslQAJuFAkYiyBgcD8DcU3Kt+g1NOsbf2az3k4b+tPvzZmv7ae86d69lvr2Y9+7Md8xqk+6cmPejsf672hSMRYAgMBF2qAZ6kESMCFIhFjCQwEHv93+fgm5ZuXs1Nv6+nX1jOffoyZz/lTPvW2fs1nfTpPq6d8np/51Bkzn+dZ81mfYm+oREhdAgUBF6qAZaoEEgEXKhFSl0BBYP47VNHrI5Vv3Ntv4Kf90nnT+VjPfOpt/PT5OW/qR53nSX5tPv1YzzjNx/wUe0MlQuoSKAi4UAUsUyWQCLhQiZC6BAoC89+h2ItvWL5RGbOeMfOTP/XkRz3FrT/zeR7GKZ/zMZ8649SP+cmfeuvP/LY/81PMfmn+5EfdG4pEjCUwEHChBniWSoAEXCgSMZbAQGD+O1R6g1LnrOlNy/wUr36sZ790HuYzTv7MZ9z2Zz/WJ539GbOeeorTPG0989f56Jdib6hESF0CBQEXqoBlqgQSARcqEVKXQEHg+jcUe/MNyzcz8xmznjr9mL/q7NfG7M/6NG+bTz/Wp3mYz5j+9KPO+jamP+vXfvRf/byh+BsylsBAwIUa4FkqARJwoUjEWAIDgfkbauj9UZresNTXfumNzH7MTzrnS/mtTn/OR53+1FnPfOqsZ8x66m3c9qd/mmf1Zz9vKBIxlsBAwIUa4FkqARJwoUjEWAIDgevfUOnNmmZd37Spf+tPv7Y+nZf+KZ/923r63/Zb/dd5btfzPCn2hkqE1CVQEHChClimSiARcKESIXUJFATmbyi+4fmG5SzMp8762/nsx5j9qXOeNZ9+7NfGnIf+1OnPfOqpnvkpTv1SfdJvz5v6eUMlQuoSKAi4UAUsUyWQCLhQiZC6BAoC8zdU0euR1PQG5xs65T8y5Itpmof6S+n//bE9D/3Xeg5Fv7Yf8+nPmP2oM6Y/66mzPsXeUImQugQKAi5UActUCSQCLlQipC6BgsD8b5vzDVr0/lOpfOMy5jyMmZ+GYH3Kp85+rR/z6Zf6UU9+SV/9WJ/idh7yYT37MZ96G3tDtcTMl8CBgAt1gKMkgZaAC9USM18CBwLzNxS9b79J0xuY+u3+6XypP3X6pbg9T+pHv5Sf9Hb+1o/zpn6tP/PbfpzHG4pEjCUwEHChBniWSoAEXCgSMZbAQOD6NxRn4RuVOuP1DUu/Nua8aZ6ksz/z2Y8x61Oc/FnPfOppnlRPvxSnfqmeOuejP3XWt7E3VEvMfAkcCLhQBzhKEmgJuFAtMfMlcCDw+DfUofcjEt/IbMI3c8pPevKnTj/Ok/KpM37aP83LeRines7P+jVmf/aj3vbzhmqJmS+BAwEX6gBHSQItAReqJWa+BA4E3u4bimdd38Spnm/wtn9bz3zOR51xOx/zW7+UT3+eh3qKUz/qaz/O4w1FIsYSGAi4UAM8SyVAAi4UiRhLYCDw+DfU7Tcqz0p/vpEZM59+jFM9/ZhPP+ZTvx2zH+djzHzOQ531zG9j+qV+1Nkv+TF/jb2hVoLWS+CFgAv1AsMfJbAScKFWgtZL4IXA/G+b84364v3Ij3wzp/7MT0MlP9bTn/XUWd/G9E/1bf/b/smP87X5PD/rkz91+rWxN1RLzHwJHAi4UAc4ShJoCbhQLTHzJSABCUhAAhKQgAQkIAEJSEACEpCABCQgAQlIQAISkIAEJCABCUhAAhKQgAQkIAEJSEACEpCABCQgAQlIQAISkIAEJCABCUhAAm9A4D9y+n3qTXv9RQAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFal);
export default __webpack_public_path__ + "static/media/logo-fal.24e2e42770d7b15370e6c5b3a8414253.svg";
export { ForwardRef as ReactComponent };